// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./turbo_streams"
import * as bootstrap from "bootstrap"


// MAKE BOOTSTRAP GLOBAL
window.bootstrap = bootstrap


document.addEventListener("turbo:load", () => {
  if (!document.querySelector("turbo-frame")) {
    window.scrollTo(0, 0)
  }
})

